import {

  CORE_SEARCH_ROOMS_REQUEST,
  CORE_SEARCH_ROOMS_SUCCESS,
  CORE_ROOMS_CLEAR,

  CORE_LOAD_ROOMINFO_REQUEST,
  CORE_LOAD_ROOMINFO_SUCCESS,

  LOAD_ROOMINFO_REQUEST,
  LOAD_ROOMINFO_SUCCESS,

  CORE_LOAD_SLOTS_SUCCESS,
  CORE_LOAD_SLOTS_REQUEST,

  CORE_LOAD_ROOMS_SUGGEST_REQUEST,
  CORE_LOAD_ROOMS_SUGGEST_SUCCESS,

  CORE_LOAD_ROOMS_FIRST_SUGGEST_REQUEST,
  CORE_LOAD_ROOMS_FIRST_SUGGEST_SUCCESS,

  CORE_LOAD_ROOMS_REQUEST,
  CORE_LOAD_ROOMS_SUCCESS,

  CORE_LOAD_ROOM_FORMAT_REQUEST,
  CORE_LOAD_ROOM_FORMAT_SUCCESS,

  CORE_LOAD_ROOM_TYPE_REQUEST,
  CORE_LOAD_ROOM_TYPE_SUCCESS,

  CORE_SAVE_FORMSUGGEST,
  CORE_LOAD_SETTINGS_REQUEST,
  CORE_LOAD_SETTINGS_SUCCESS,

  CORE_LOAD_ROLESETTINGS_REQUEST,
  CORE_LOAD_ROLESETTINGS_SUCCESS,

  CORE_SAVE_FORMSEARCHNAME,
  CORE_CLEAR_FORMSEARCHNAME
} from '../../types'

const initialState = []
export default {
  rooms: (state = initialState, action) => {
    switch (action.type) {
      case CORE_SEARCH_ROOMS_REQUEST:
      case CORE_LOAD_ROOMS_REQUEST:
        return initialState
      case CORE_SEARCH_ROOMS_SUCCESS:
      case CORE_LOAD_ROOMS_SUCCESS:
        if (action.payload[0]) {
          return action.payload[0]
        }
        else return []
      case CORE_ROOMS_CLEAR:
        return []
      default:
        return state
    }
  },
  roomssuggest: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ROOMS_SUGGEST_REQUEST:
        return {}
      case CORE_LOAD_ROOMS_SUGGEST_SUCCESS:
        if (action.payload) {
          let payload = action.payload
          return payload
        }
        else return {}

      default:
        return state
    }
  },
  roomsfirstsuggest: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ROOMS_FIRST_SUGGEST_REQUEST:
        return {}
      case CORE_LOAD_ROOMS_FIRST_SUGGEST_SUCCESS:
        if (action.payload) {
          let payload = action.payload
          return payload
        }
        else return {}

      default:
        return state
    }
  },
  roomInfo: (state = {}, action) => {
    switch (action.type) {
      case CORE_LOAD_ROOMINFO_REQUEST:
      case LOAD_ROOMINFO_REQUEST:
        return {}
      case CORE_LOAD_ROOMINFO_SUCCESS:
      case LOAD_ROOMINFO_SUCCESS:
        if (action.payload) {
          return action.payload
        }
        else return {}
      default:
        return state
    }
  },
  slots: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_SLOTS_REQUEST:
        return initialState
      case CORE_LOAD_SLOTS_SUCCESS:
        if (action.payload[0]) {
          return action.payload
        }
        else return [{}]

      default:
        return state
    }
  },
  roomFormat: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ROOM_FORMAT_REQUEST:
        return initialState
      case CORE_LOAD_ROOM_FORMAT_SUCCESS:
        if (action.payload) {
          return action.payload
        }
        else return []
      default:
        return state
    }
  },
  roomType: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ROOM_TYPE_REQUEST:
        return initialState
      case CORE_LOAD_ROOM_TYPE_SUCCESS:
        if (action.payload) {
          return action.payload
        }
        else return []
      default:
        return state
    }
  },
  formSuggest: (state = initialState, action) => {
    switch (action.type) {
      case CORE_SAVE_FORMSUGGEST:
        return action.form
      default:
        return state
    }
  },
  formSearchName: (state = {}, action) => {
    switch (action.type) {
      case CORE_SAVE_FORMSEARCHNAME:
        return action.form
      case CORE_CLEAR_FORMSEARCHNAME:
        return {}
      default:
        return state
    }
  },
  settings: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_SETTINGS_REQUEST:
        return initialState
      case CORE_LOAD_SETTINGS_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
  roleSetting: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ROLESETTINGS_REQUEST:
        return initialState
      case CORE_LOAD_ROLESETTINGS_SUCCESS:
        return action.payload
      default:
        return state
    }
  }
}


// WEBPACK FOOTER //
// ./src/front/features/rooms/reducer.js